
























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay } from '@/utils/dateTime'
import FoldingCard from '@/components/FoldingCard.vue'
import { ApolloResponse } from '@/interfaces/apollo'
import { getPolicyHistories } from '../gql/policy.gql'
import { History } from '@/modules/History/interfaces/history'
import PolicyHistoryDetail from '../components/HistoryDetail.vue'

@Component({
  components: {
    FoldingCard,
    PolicyHistoryDetail
  }
})
export default class PolicyDetailHistory extends Vue {
  logs: History[] = []
  dateTimeToDisplay = dateTimeToDisplay

  activeItem: History | null = null

  mounted () {
    this.getPolicyHistories()
  }

  async getPolicyHistories () {
    const policyId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getPolicyHistories,
        variables: {
          policyId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.parseLogs(result.data.getPolicyHistories)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  parseLogs (histories: History[]) {
    const logs = histories.map(history => {
      let message = ''
      switch (history.actionCode) {
        case '0800':
          message = 'Create the policy'
          break
        case '0801':
          message = 'Update the policy'
          break
        case '0802':
          message = 'Delete the policy'
          break
        case '0803':
          message = 'Update the premium-payment status'
          break
        case '0804':
          message = 'Update the commission-completed status'
          break
        case '0805':
          message = 'Update the non-renew status'
          break
        case '0806':
          message = 'Update the auto-cancel status'
          break
        case '0810':
          message = 'Create a new payment'
          break
        case '0811':

          message = 'Update a payment'
          break
        case '0812':
          message = 'Delete a payment'
          break
        case '0820':
          message = 'Create a new commission'
          break
        case '0821':
          message = 'Update a commission'
          break
        case '0822':
          message = 'Delete a commission'
          break
        case '0830':
          message = 'Create a new association between policies'
          break
        case '0831':
          message = 'Update an association between policies'
          break
        case '0832':
          message = 'Delete an association between policies'
          break
        case '0840':
          message = 'Create a new Endorsement'
          break
        case '1700':
          message = 'Upload a new file'
          break
        case '1701':
          message = 'Rename a file'
          break
        case '1702':
          message = 'Delete a file'
          break
        default:
          break
      }

      return {
        ...history,
        message
      }
    })

    this.logs = logs
  }

  onItemClick (item: History) {
    if (!this.ifCanClick(item)) {
      return
    }
    this.activeItem = item
  }

  onDialogClose () {
    this.activeItem = null
  }

  ifCanClick (item: History) {
    return item.actionCode === '0801'
  }
}
